import React from "react";
import { Typography } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { DATA_GRID_FONT_SIZE } from "../../../components/ui/dataGridStyles";
import CatalogUtils from "../../../utils/CatalogUtils";

/**
 * Columnas del DataGrid de asignaciones de reponedores
 *
 * Los nombres de empleados y almacenes se resuelven en valueGetter, no en
 * renderCell, para que el orden y el filtrado del grid trabajen sobre el nombre
 * visible y no sobre el id o el código crudos.
 */
export const generateReponedorColumns = (usuarios, almacenes, { onEditar, onEliminar }) => [
    {
        field: 'id',
        headerName: 'ID',
        width: 80,
        renderCell: (params) => (
            <Typography sx={{ fontWeight: 600, fontSize: DATA_GRID_FONT_SIZE.CELDA }}>
                #{params.value}
            </Typography>
        ),
    },
    {
        field: 'usuarios',
        headerName: 'Empleados',
        flex: 1,
        minWidth: 200,
        valueGetter: (params) => {
            const ids = params.row.usuarios ?? [];
            const nombres = ids.map(id =>
                CatalogUtils.getNombreEmpleado(id, usuarios)
            );
            return nombres.join(', ');
        }
    },
    {
        field: 'almacenes',
        headerName: 'Almacenes',
        flex: 1,
        minWidth: 200,
        valueGetter: (params) => {
            const codigos = params.row.almacenes ?? [];
            const almacenesCompletos = codigos.map(codigo =>
                CatalogUtils.getNombreAlmacen(codigo, almacenes)
            );
            return almacenesCompletos.join(', ');
        }
    },
    {
        field: 'actions',
        type: 'actions',
        headerName: 'Acciones',
        width: 120,
        sortable: false,
        filterable: false,
        getActions: ({ id }) => [
            <GridActionsCellItem
                key="edit"
                icon={<EditIcon />}
                label="Editar"
                onClick={() => onEditar(id)}
                sx={{ color: '#495057' }}
            />,
            <GridActionsCellItem
                key="delete"
                icon={<DeleteIcon />}
                label="Eliminar"
                onClick={() => onEliminar(id)}
                color="error"
            />
        ]
    }
];
